var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.336,
    height: 12.893,
    viewBox: "0 0 18.336 12.893",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-ico",
    transform: "translate(0 -76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_11720",
    "data-name": "Groupe 11720",
    transform: "translate(0 76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1319",
    "data-name": "Trac\\xE9 1319",
    d: "M16.725,76H1.612A1.614,1.614,0,0,0,0,77.612v9.67a1.614,1.614,0,0,0,1.612,1.612H16.725a1.614,1.614,0,0,0,1.612-1.612v-9.67A1.614,1.614,0,0,0,16.725,76Zm-.247,1.074L9.585,83.99a.627.627,0,0,1-.833,0L1.859,77.074ZM1.074,87.084V77.809L5.7,82.446Zm.785.735,4.6-4.611,1.536,1.541a1.7,1.7,0,0,0,2.354,0l1.536-1.541,4.6,4.611Zm15.4-.735L12.64,82.446l4.622-4.637Z",
    transform: "translate(0 -76)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIco);
export default __webpack_public_path__ + "static/media/mail-ico.25cd33ea2b242e500ccc8c958bcdc2ac.svg";
export { ForwardRef as ReactComponent };